import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./Badge.css.js";
// A small status pill: member role ("editor"/"viewer"), an owner badge, or a
// "managed by Alex" tag for managed members (Doc 05 §5).
export const Badge = ({ children, tone = "neutral" }) => (_jsx("span", { className: [styles.base, styles.tone[tone]].join(" "), children: children }));
//# sourceMappingURL=Badge.js.map